import { render } from "./TopStrip.vue?vue&type=template&id=0031124a&scoped=true"
import script from "./TopStrip.vue?vue&type=script&lang=js"
export * from "./TopStrip.vue?vue&type=script&lang=js"

import "./TopStrip.vue?vue&type=style&index=0&id=0031124a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0031124a"]])

export default __exports__